export default __webpack_public_path__ + "static/media/Print.8dd5128a.svg";